import React from 'react';
import { Button } from '@openedx/paragon';
import { RiPlayMiniLine } from '@remixicon/react';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '../messages';

const ProgramProgressCard = ({
  completed, total, percent, continueUrl,
}) => {
  const intl = useIntl();
  const clamped = Math.max(0, Math.min(100, percent));

  return (
    <section className="program-inner__card program-inner__progress">
      <div className="program-inner__progress-header">
        <h2 className="program-inner__card-title">
          {intl.formatMessage(messages.progressTitle)}
        </h2>
        <Button
          variant="primary"
          iconBefore={RiPlayMiniLine}
          as="a"
          href={continueUrl || undefined}
          disabled={!continueUrl}
        >
          {intl.formatMessage(messages.continueLearning)}
        </Button>
      </div>
      <div className="program-inner__progress-body">
        <div className="program-inner__progress-labels">
          <span>
            {intl.formatMessage(messages.completedCount, { completed, total })}
          </span>
          <span>{clamped}%</span>
        </div>
        <div
          className="program-inner__progress-track"
          role="progressbar"
          aria-label={intl.formatMessage(messages.progressTitle)}
          aria-valuenow={clamped}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <div
            className="program-inner__progress-fill"
            style={{ width: `${clamped}%` }}
          />
        </div>
      </div>
    </section>
  );
};

export default ProgramProgressCard;
